export default "__VITE_ASSET__b5c1fdb0__"